import iLive from "../../assets/images/100-live-with-bg.svg";
import defaultImage from "../../assets/tutorial-items/i10.svg";

export default function CourseCard({ course, selected, onClick }) {
  return (
    <div className={`create-meeting-thumbnail ${selected ? "disable" : ""}`} onClick={onClick}>
      <div className="meeting-thumbnail-info meeting-thumbnail-selectable">
        <div className="space-between">
          <div className="flex">
            <div className="meeting-thumbnail-detail">
              <img src={iLive} alt="" />
              <div className="p-r-6"> {course.duration || "00:00"} </div>
              <div className="divider-vertical h-12 m-0 m-lr-6" />
              <div className="flex p-l-6">
                Screens
                <div className="badge m-l-4"> {course.screens?.length || 0} </div>
              </div>
              <div className="flex p-l-6">
                Steps
                <div className="badge m-l-4"> {course.steps?.length || 0} </div>
              </div>
            </div>
          </div>
        </div>
        <div className="meeting-thumbnail-description">
          <span>{`${course.title || ""} c${course.cid}`}</span>
        </div>
      </div>
      <img src={course.img || defaultImage} className="meeting-thumbnail-img" alt="" />
    </div>
  );
}
